<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-two-central-italy-present-day">
<h1 class="main">Part Two<br/> (Central Italy, Present Day)</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?2e98ad1e